import { CSSProperties } from 'react';

import {
  AssistantOutcomeFragment,
  ConversationsV2ChatState,
} from '@spotify/confidence-graphql';

type ChatStatusDotProps = {
  state?: ConversationsV2ChatState | null;
  assistantOutcome?: AssistantOutcomeFragment | null;
  renderIdle?: boolean;
  className?: string;
  style?: CSSProperties;
};

type Status = 'running' | 'error' | 'attention' | 'idle';

const STATUS_COLOR: Record<Status, string> = {
  running: 'var(--bui-fg-success)',
  error: 'var(--bui-fg-danger)',
  attention: 'var(--bui-fg-warning)',
  idle: 'var(--bui-fg-secondary)',
};

const getStatus = (
  state?: ConversationsV2ChatState | null,
  assistantOutcome?: AssistantOutcomeFragment | null,
): Status => {
  if (state === ConversationsV2ChatState.Running) return 'running';
  if (assistantOutcome?.error) return 'error';
  if (assistantOutcome?.toolConfirmation || assistantOutcome?.askQuestion) {
    return 'attention';
  }
  return 'idle';
};

export const ChatStatusDot = ({
  state,
  assistantOutcome,
  renderIdle = false,
  className,
  style,
}: ChatStatusDotProps) => {
  const status = getStatus(state, assistantOutcome);
  if (status === 'idle' && !renderIdle) return null;
  return (
    <span
      aria-hidden="true"
      className={className}
      style={{
        backgroundColor: STATUS_COLOR[status],
        borderRadius: '50%',
        display: 'inline-block',
        flexShrink: 0,
        height: 6,
        width: 6,
        ...style,
      }}
    />
  );
};
